








































import Vue from "vue";
import { Action, Getter } from "vuex-class";
import { Component } from "vue-property-decorator";
import { ErrorMessage } from "@/shared";

@Component
export default class AppLogin extends Vue {
  @Action("login", { namespace: "auth" }) login: any;
  @Action("showMessage", { namespace: "notification" }) showMessage: any;
  @Getter("isAuthenticated", { namespace: "auth" }) isAuthenticated: any;

  email = "";
  password = "";
  error: string | null = null;

  async performLogin() {
    if (this.email && this.password) {
      try {
        await this.login({ username: this.email, password: this.password });
      } catch (error) {
        if (!this.isAuthenticated)
          this.showMessage(new ErrorMessage("Invalid username or password."));
      }
    }
  }
}
